// extracted by mini-css-extract-plugin
module.exports = {"modalPromotion":"ReactModal_modalPromotion__1hkm4"};